// extracted by mini-css-extract-plugin
module.exports = {"container":"FavoriteCheckbox-module__container--2g6cM","checkbox":"FavoriteCheckbox-module__checkbox--1DRBM","text":"FavoriteCheckbox-module__text--2dfNr"};